<template>
  <b-col class="mt-2">
    <div class="accordion" role="tablist" style="width:100%">
      <div class="accordion-wrapper">
        <div v-b-toggle="`${id}-features`">
          <div class="row align-items-center no-gutters">
            <div class="col d-flex">
              <i :class="`fa-fw fa-check-circle check-icon mr-2 ${isCovered ? 'fas' : 'far'}`" />
              <div>
                <p class="mb-0">{{ generatorName }}</p>
                <p class="receives-features-text">
                  {{ isCovered ? $t('xReceivesPremiumFeatures') : $t('xNotIncludedInPlan') }}
                </p>
              </div>
            </div>
            <div class="col-auto">
              <i class="fas fa-chevron-down when-closed"></i>
              <i class="fas fa-chevron-up when-open"></i>
            </div>
          </div>
        </div>
        <b-collapse :id="`${id}-features`">
          <div class="features">
            <div class="basic">
              <p class="mb-1">
                <strong>{{ $t('xFeaturesIncludedInPlan') }}{{ $t('xBasic') }}</strong>
              </p>
              <div class="feature">
                <i class="far fa-fw fa-clipboard-list"></i>
                <div>
                  <p class="basic-features">
                    {{ $t('xFeaturesIncludedWiFiAnnuallySubscriptionFeature1') }}
                  </p>
                </div>
              </div>
            </div>
            <div class="premium">
              <p class="mb-1">
                <strong>{{ $t('xAdditionalFeatuesInPremium') }}</strong>
              </p>
              <div class="feature">
                <i class="far fa-fw fa-bell"></i>
                <div class="mb-2">
                  <p class="premium-feature-text">
                    {{ $t('xRealTimeAlerts') }}
                  </p>
                  <p class="premium-feature-supporting-text">
                    {{ $t('xRealTimeAlertsDesc') }}
                  </p>
                </div>
              </div>
              <div class="feature">
                <i class="far fa-fw fa-calendar"></i>
                <div class="mb-2">
                  <p class="premium-feature-text">
                    {{ $t('xExerciseSettings') }}
                  </p>
                  <p class="premium-feature-supporting-text">
                    {{ $t('xExerciseSettingsDesc') }}
                  </p>
                </div>
              </div>
              <div class="feature">
                <i class="far fa-fw fa-arrows-spin"></i>
                <div class="mb-2">
                  <p class="premium-feature-text">
                    {{ $t('xExerciseOnDemand') }}
                  </p>
                  <p class="premium-feature-supporting-text">
                    {{ $t('xExerciseOnDemandDesc') }}
                  </p>
                </div>
              </div>
              <div class="feature">
                <i class="far fa-fw fa-warning"></i>
                <div>
                  <p class="premium-feature-text">
                    {{ $t('xDismissWarnings') }}
                  </p>
                  <p class="premium-feature-supporting-text">
                    {{ $t('xDismissWarningsDesc') }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </b-collapse>
      </div>
    </div>
  </b-col>
</template>

<script>
export default {
  props: ['generatorName', 'id', 'isCovered']
}
</script>
<style lang="scss">
.receives-features-text {
  color: var(--carbon-600);
  font-size: 0.875em;
  line-height: 1.35;
}
.collapsed .when-open,
.not-collapsed .when-closed {
  display: none;
}
.features {
  margin-top: 0.5em;
  gap: 0.75em;
  display: flex;
  flex-direction: column;
}
.feature {
  display: flex;
  align-items: center;
  gap: 0.5em;

  i {
    font-size: 1.125em;
    color: var(--carbon-600);
  }
  div {
    flex: 1;
  }
}
.basic-features {
  font-size: 0.875em;
  line-height: 1.35;
  margin-bottom: 0;
}
.premium-feature-text {
  font-weight: 600;
  font-size: 0.875em;
  line-height: 1.35;
  margin-bottom: 2px;
}
.premium-feature-supporting-text {
  font-size: 0.875em;
  line-height: 1.35;
  margin-bottom: 0;
  color: var(--carbon-600);
}
</style>
